import { takeEvery } from 'redux-saga/effects'

import { LimitReachedActions } from '../actions'
import { alert } from './alert'

export function* limitReachedSaga() {
  yield takeEvery(LimitReachedActions.alert, alert)
}
